import { render } from "./RandDice.vue?vue&type=template&id=1456a260&scoped=true"
import script from "./RandDice.vue?vue&type=script&lang=js"
export * from "./RandDice.vue?vue&type=script&lang=js"

import "./RandDice.vue?vue&type=style&index=0&id=1456a260&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shavin\\Documents\\apps\\10-candles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1456a260"]])

export default __exports__